export default __webpack_public_path__ + "static/media/ADEM.0c93a6dd.png";